<hyperkit-dialog class="hyperkit-component" headerText="New Hunt">
  <div class="container-fluid">
    <div class="row">
      <div class="container">
        <hyperkit-typography variant="body" size="md" align="left" color="body"
          >Analyze hunt packages in a single hunt.</hyperkit-typography
        >
        @if (error) {
          <hyperkit-error [error]="error"></hyperkit-error>
        }
        @if (checkWarnings && warnings.length > 0) {
          <hyperkit-notification
            type="warning"
            header="Missing field mappings"
            [closeable]="false"
            [showActions]="false"
          >
            <hyperkit-typography variant="body" size="md" color="body"
              >Some queries will use default field names instead of your
              environment's field mappings (
              <ng-container *ngFor="let env of warnings; last as isLast"
                >{{ env.envName }}: {{ env.excludedCount }}
                {{ env.excludedCount === 1 ? 'query' : 'queries'
                }}<ng-container *ngIf="!isLast">, </ng-container></ng-container
              >).
              <hyperkit-link
                variant="body"
                size="md"
                color="secondary"
                underline="always"
                display="inline"
                text="Configure environments"
                (click)="goToEnvironmentSettings()"
              ></hyperkit-link>
              to use your custom mappings.</hyperkit-typography
            >
          </hyperkit-notification>
        }
        <form class="k-form" [formGroup]="formGroup" autocomplete="off">
          <hyperkit-input
            class="hyperkit-component"
            type="text"
            id="name"
            label="Name"
            formControlName="name"
          >
          </hyperkit-input>
          <hyperkit-multiselect
            label="Environments"
            [options]="environments"
            displayProperty="name"
            formControlName="environments"
            valueProperty="id"
            (selectionChange)="onValueChange($event)"
          >
          </hyperkit-multiselect>
          <hyperkit-select
            label="Priority"
            [options]="priorities"
            formControlName="priority"
          ></hyperkit-select>
          <hyperkit-select
            label="Assignee"
            [displayProperty]="'fullName'"
            [valueProperty]="'id'"
            [options]="assignees$ | async"
            formControlName="assignee"
          ></hyperkit-select>
          <hyperkit-button
            size="medium"
            color="tertiary"
            type="submit"
            [disabled]="!formGroup.valid"
            (click)="onSubmit()"
            text="Save"
          >
          </hyperkit-button>
        </form>
      </div>
      @if (environments?.length === 0) {
        <hyperkit-message
          [closable]="false"
          (click)="goToEnvironmentSettings()"
          text="You need at least one environment to create a hunt."
          type="warning"
          actionText="Configure"
          (actionTriggered)="goToEnvironmentSettings()"
        ></hyperkit-message>
      }
    </div>
  </div>
</hyperkit-dialog>
